"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.key = void 0;
exports.key = {
    $grammar: {
        "key:name": [{ name: "name" }],
        "key:quote": [{ data: { $pattern: ["string"] } }],
    },
};
//# sourceMappingURL=key.js.map